import { defineMessages } from 'react-intl'

const scope = `procurify.modules.spending-cards.components.BlockedCardAlert`

export default defineMessages({
  blockedCardAlertText: {
    id: `${scope}.blockedCardAlertText`,
    defaultMessage:
      "This card is permanently blocked and can't be used again. To cancel it, <a>contact support</a>.",
  },
})
